import {
  GitMergeIcon,
  GitMergeQueueIcon,
  GitPullRequestClosedIcon,
  GitPullRequestDraftIcon,
  GitPullRequestIcon,
  type Icon,
} from '@primer/octicons-react'

type SourceIconType = {color: string; icon: Icon}

export const PullRequestStateIcons = {
  MERGED: {
    color: 'var(--fgColor-done)',
    icon: GitMergeIcon,
  },
  IN_MERGE_QUEUE: {
    color: 'var(--fgColor-attention)',
    icon: GitMergeQueueIcon,
  },
  OPEN: {
    color: 'var(--fgColor-open)',
    icon: GitPullRequestIcon,
  },
  CLOSED: {
    color: 'var(--fgColor-closed)',
    icon: GitPullRequestClosedIcon,
  },
  DRAFT: {
    color: 'var(--fgColor-draft)',
    icon: GitPullRequestDraftIcon,
  },
} as const satisfies Record<string, SourceIconType>
